var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graphCalendar",on:{"click":function (){_vm.initGradiantPrimaryColor(),_vm.updateChat()}}},[_c('canvas',{attrs:{"id":_vm.id,"width":500 * 2,"height":400}})])}
var staticRenderFns = []

export { render, staticRenderFns }